/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Mode_Streak_DescriptionInputs */

const bn_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দীর্ঘতম সঠিক উত্তরের ধারা তৈরি করুন।`)
};

const de_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bauen Sie die längste Serie richtiger Antworten auf.`)
};

const el_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δημιουργήστε τη μεγαλύτερη σειρά σωστών απαντήσεων.`)
};

const en_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build longest correct-answer streak.`)
};

const es_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construya la racha más larga de respuestas correctas.`)
};

const fr_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construisez la plus longue série de bonnes réponses.`)
};

const hi_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबसे लंबी सही-उत्तर वाली पंक्ति बनाएं.`)
};

const hu_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Építsd fel a leghosszabb helyes válaszsorozatot.`)
};

const id_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat rangkaian jawaban benar terpanjang.`)
};

const it_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costruisci una serie di risposte corrette più lunga.`)
};

const ja_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最長連続正解数を築きましょう。`)
};

const ko_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가장 긴 연속 정답을 기록하세요.`)
};

const nl_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bouw de langste reeks met correcte antwoorden op.`)
};

const pl_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zbuduj najdłuższą passę poprawnych odpowiedzi.`)
};

const pt_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie a sequência de respostas corretas mais longa.`)
};

const ru_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создайте самую длинную серию правильных ответов.`)
};

const sv_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygg längsta rätt svarsrad.`)
};

const tr_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En uzun doğru cevap serisini oluşturun.`)
};

const uk_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Створіть найдовшу серію правильних відповідей.`)
};

const vi_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xây dựng chuỗi câu trả lời đúng dài nhất.`)
};

const zh_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立最长的正确答案连续记录。`)
};

const zh_hant_intro_mode_streak_description = /** @type {(inputs: Intro_Mode_Streak_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立最長的正確答案連續記錄。`)
};

/**
* | output |
* | --- |
* | "Build longest correct-answer streak." |
*
* @param {Intro_Mode_Streak_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_mode_streak_description = /** @type {((inputs?: Intro_Mode_Streak_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Mode_Streak_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_mode_streak_description(inputs)
	if (locale === "de") return de_intro_mode_streak_description(inputs)
	if (locale === "el") return el_intro_mode_streak_description(inputs)
	if (locale === "en") return en_intro_mode_streak_description(inputs)
	if (locale === "es") return es_intro_mode_streak_description(inputs)
	if (locale === "fr") return fr_intro_mode_streak_description(inputs)
	if (locale === "hi") return hi_intro_mode_streak_description(inputs)
	if (locale === "hu") return hu_intro_mode_streak_description(inputs)
	if (locale === "id") return id_intro_mode_streak_description(inputs)
	if (locale === "it") return it_intro_mode_streak_description(inputs)
	if (locale === "ja") return ja_intro_mode_streak_description(inputs)
	if (locale === "ko") return ko_intro_mode_streak_description(inputs)
	if (locale === "nl") return nl_intro_mode_streak_description(inputs)
	if (locale === "pl") return pl_intro_mode_streak_description(inputs)
	if (locale === "pt") return pt_intro_mode_streak_description(inputs)
	if (locale === "ru") return ru_intro_mode_streak_description(inputs)
	if (locale === "sv") return sv_intro_mode_streak_description(inputs)
	if (locale === "tr") return tr_intro_mode_streak_description(inputs)
	if (locale === "uk") return uk_intro_mode_streak_description(inputs)
	if (locale === "vi") return vi_intro_mode_streak_description(inputs)
	if (locale === "zh") return zh_intro_mode_streak_description(inputs)
	return zh_hant_intro_mode_streak_description(inputs)
});